import { Injectable, inject } from '@angular/core'
import { LOCAL_CLIENT_ID, LOCAL_TOKEN, LOCAL_REFRESH_TOKEN } from '@monorepo-channels/shared/util-helpers'
import { Client } from '../models/client/client'
import { HttpClient } from '@angular/common/http'
import { environment } from '@monorepo-channels/shared/util-environments'
import { tap } from 'rxjs'

interface AuthResponse {
	accessToken: string
	refreshToken?: string
}

interface PicPayAuthResponse {
	_id: string
	partnerId: string
	externalUserId: string
	tokens: {
		accessToken: string
		refreshToken: string
	}
}

@Injectable({ providedIn: 'root' })
export class AuthService {
	private httpService = inject(HttpClient)
	private env = environment
	public redirectURL = '/'

	logout() {
		localStorage.removeItem(LOCAL_TOKEN)
		localStorage.removeItem(LOCAL_REFRESH_TOKEN)
		localStorage.removeItem(LOCAL_CLIENT_ID)
	}

	getClientIdAndToken() {
		return { token: this.getToken(), clientId: this.getClientId() }
	}

	setClientId(client: Client) {
		localStorage.setItem(LOCAL_CLIENT_ID, client.id)
	}

	refreshTokens() {
		const refreshToken = this.getRefreshToken()
		return this.httpService.post<AuthResponse>(`${this.env.channelsAPIURL}/api/v1/auth/refresh`, {
			refreshToken,
		})
	}

	getClientId() {
		return localStorage.getItem(LOCAL_CLIENT_ID)
	}

	getToken() {
		return localStorage.getItem(LOCAL_TOKEN)
	}

	getRefreshToken() {
		return localStorage.getItem(LOCAL_REFRESH_TOKEN)
	}

	setRefreshToken(refreshToken: string) {
		localStorage.setItem(LOCAL_REFRESH_TOKEN, refreshToken)
	}

	setToken(token: string) {
		localStorage.setItem(LOCAL_TOKEN, token)
	}

	// Método para salvar ambos os tokens de uma vez
	setTokens(authResponse: { accessToken: string | null; refreshToken?: string | null }) {
		if (authResponse.accessToken) this.setToken(authResponse.accessToken)
		if (authResponse.refreshToken) this.setRefreshToken(authResponse.refreshToken)
	}

	// Verifica se tem refresh token disponível
	hasRefreshToken(): boolean {
		return !!this.getRefreshToken()
	}

	loginWithPicPay(externalUserId: string) {
		return this.httpService
			.post<PicPayAuthResponse>(`${this.env.channelsAPIURL}/api/v1/auth/picpay`, {
				externalUserId,
			})
			.pipe(
				tap(response => {
					this.setTokens({
						accessToken: response.tokens.accessToken,
						refreshToken: response.tokens.refreshToken,
					})
					this.setClientId({ id: response._id } as Client)
				})
			)
	}
}
